declare namespace $ {

	type $mol_select__Filter_shm_hitalama_map_widget_float_ai_request_1 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_ai_request_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['req_type_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_ai_request_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['request_type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_ai_request_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_ai_request_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['Request_type'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_button_copy__theme_shm_hitalama_map_widget_float_ai_request_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['theme'] >
	>
	type $shm_button_copy__title_shm_hitalama_map_widget_float_ai_request_7 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__text_shm_hitalama_map_widget_float_ai_request_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['prompt'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_button_major__sub_shm_hitalama_map_widget_float_ai_request_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_ai_request_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['paste'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_shm_hitalama_map_widget_float_ai_request_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_ai_request_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['next_request'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_ai_request_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_ai_request_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_ai_request_mol_dom__Widget_shm_hitalama_map_widget_float_ai_request_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['that'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_ai_request_mol_dom['Widget'] >
	>
	type $shm_hitalama_map_widget_float_ai_request_html__Widget_shm_hitalama_map_widget_float_ai_request_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['that'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_ai_request_html['Widget'] >
	>
	type $shm_hitalama_map_widget_float_ai_request_component__Widget_shm_hitalama_map_widget_float_ai_request_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['that'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_ai_request_component['Widget'] >
	>
	type $shm_hitalama_map_widget_float_ai_request_changes__Widget_shm_hitalama_map_widget_float_ai_request_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['that'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_ai_request_changes['Widget'] >
	>
	type $shm_hitalama_map_widget_float_ai_request_html_changes__Widget_shm_hitalama_map_widget_float_ai_request_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['that'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_ai_request_html_changes['Widget'] >
	>
	type $shm_hitalama_map_widget_presets__map_shm_hitalama_map_widget_float_ai_request_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_presets['map'] >
	>
	export class $shm_hitalama_map_widget_float_ai_request extends $shm_hitalama_map_widget_float {
		req_type_dict( ): ({ 
			'mol_dom': string,
			'new_app_html': string,
			'new_app': string,
			'html_changes_short': string,
			'changes_short': string,
		}) 
		request_type( next?: string ): string
		Request_type( ): $mol_select
		Request_type_label( ): $mol_labeler
		Form( ): $shm_hitalama_map_widget_float_ai_request_form
		prompt( ): string
		Copy( ): $shm_button_copy
		Paste_icon( ): $mol_icon_content_paste
		paste( next?: any ): any
		Paste( ): $mol_button_major
		Next_icon( ): $mol_icon_plus
		Next_right_icon( ): $mol_icon_chevron_double_right
		next_request( next?: any ): any
		Next( ): $mol_button_major
		Buttons( ): $mol_view
		Controls( ): $mol_view
		that( ): $shm_hitalama_map_widget_float_ai_request
		Mol_dom( ): $shm_hitalama_map_widget_float_ai_request_mol_dom
		New_app_html( ): $shm_hitalama_map_widget_float_ai_request_html
		New_app( ): $shm_hitalama_map_widget_float_ai_request_component
		Changes( ): $shm_hitalama_map_widget_float_ai_request_changes
		Html_changes( ): $shm_hitalama_map_widget_float_ai_request_html_changes
		presets( ): $shm_hitalama_map_widget_presets
		controls( ): readonly(any)[]
		forms( ): ({ 
			'mol_dom': ReturnType< $shm_hitalama_map_widget_float_ai_request['Mol_dom'] >,
			'new_app_html': ReturnType< $shm_hitalama_map_widget_float_ai_request['New_app_html'] >,
			'new_app': ReturnType< $shm_hitalama_map_widget_float_ai_request['New_app'] >,
			'changes_short': ReturnType< $shm_hitalama_map_widget_float_ai_request['Changes'] >,
			'html_changes_short': ReturnType< $shm_hitalama_map_widget_float_ai_request['Html_changes'] >,
		}) 
	}
	
}

//# sourceMappingURL=request.view.tree.d.ts.map